import { render, staticRenderFns } from "./qywx.vue?vue&type=template&id=66a42ad2&"
import script from "./qywx.vue?vue&type=script&lang=js&"
export * from "./qywx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports